<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Group Subscriptions</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4">
              New Group Subscription
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-select
                v-model="selectedObj.userGroup"
                :rules="groupRules"
                :items="groups"
                label="User Group"
                item-text="Name"
                item-value="id"
                return-object
                required
              ></v-select>
            </div>
            <div class="col">
              <v-select
                v-model="selectedObj.collection"
                :rules="collectionRules"
                :items="collection"
                label="Collections"
                item-text="Name"
                item-value="id"
                return-object
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <v-radio-group
                v-model="selectedObj.subscriptionType"
                row
                v-on:change="onTypeChanges"
              >
                <v-radio label="Loan" value="Loan"></v-radio>
                <v-radio label="Buy" value="Buy" v-if="false"></v-radio>
              </v-radio-group>
            </div>
            <div class="col">
              <div v-show="isLoan">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedStartDateFormatted"
                      :rules="startDateRules"
                      label="Start Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="col">
              <div v-show="isLoan">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted"
                      :rules="endDateRules"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()"> Cancel </v-btn>
                <v-btn
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Group</th>
                  <th class="text-left">Collection</th>
                  <th class="text-left">Type</th>
                  <th class="text-left">Start Date</th>
                  <th class="text-left">End Date</th>
                  <th style="width: 140px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.userGroup.Name }}</td>
                  <td>{{ item.collection.Name }}</td>
                  <td>{{ item.subscriptionType }}</td>
                  <td>{{ item.startDate | dateUtcToLocal }}</td>
                  <td>{{ item.endDate | dateUtcToLocal }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                    <!---
                    <v-icon
                      class="mr-2 mdi-library-books"
                      @click="onSubscriptionDetails(item)"
                      >mdi-license</v-icon
                    > -->
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "OrgGroupSubscription",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  created() {
    this.getSubscriptionByPagin();
    this.getCollection();
    this.getUserGroups();
  },
  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedDateFormatted() {
      return this.formatDate(this.endDate);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.name.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },
  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getSubscriptionByPagin();
    },
    onNew() {
      this.isEdit = true;
      (this.valid = true), (this.selectedObj.id = 0);
      this.selectedObj.subscriptionType = "Loan";
      this.selectedObj.endDate = "";
      this.selectedObj.status = "";
      this.selectedObj.userGroup = {};
      this.selectedObj.collection = {};
      this.endDate = "";
      this.startDate = null;
    },
    onSave() {
      //this.selectedObj.type = isLoan==true ? 'Loan' : 'Buy';
      this.selectedObj.startDate = this.computedStartDateFormatted;
      this.selectedObj.endDate = this.computedDateFormatted;
      console.log(this.selectedObj);

      //this.$refs.form.validate();
      //console.log(this.valid);
      //if (!this.valid) return;

      if (this.validateFrom()) return;

      if (this.valid) {
        this.loading = true;
        new Promise((resolve, reject) => {
          api
            .update("user-group-subscription", this.selectedObj)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message =
                  this.selectedObj.id === -1
                    ? "Record successfully saved."
                    : "Record successfully updated.";
                this.loading = false;
                this.isEdit = false;
                this.getSubscriptionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
                this.loading = false;
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              if (error == "Error: Request failed with status code 409")
                this.notify.errors.push(
                  "Selected group  and collection already exist."
                );
              else if (error == "Error: Request failed with status code 410") {
                this.notify.errors.push("Maximum Seat count exceed. ");
                this.loading = false;
                reject(error);
              } else this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
              reject(error);
            });
        });
      }
    },
    onEdit(obj) {
      this.isEdit = true;
      this.endDate =
        obj.endDate == null
          ? null
          : new Date(obj.endDate).toISOString().substr(0, 10);

      this.startDate =
        obj.startDate == null
          ? null
          : new Date(obj.startDate).toISOString().substr(0, 10);
      this.selectedObj = Object.assign({}, obj);
      this.collectionEndDate = obj.collection.endDate;
    },
    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("user-group-subscription", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getSubscriptionByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
    },
    getSubscription() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user-group-subscription")
          .then((response) => {
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getSubscriptionByPagin();
    },
    getSubscriptionByPagin() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("user-group-subscription", this.paging)
          .then((response) => {
            console.log(response.data);
            this.paging.count = response.data.count;
            this.list = response.data.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCollection() {
      this.collection = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization-purchases/organization-collections")
          .then((response) => {
            console.log(response.data);
            this.collection = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUserGroups() {
      this.groups = [];
      new Promise((resolve, reject) => {
        api
          .getAll("user-group")
          .then((response) => {
            this.groups = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    validateFrom() {
      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.type = 4;

      if (this.selectedObj.userGroup.id === undefined) {
        this.notify.errors.push("Group is required.");
        return true;
      }
      if (this.selectedObj.collection.id == undefined) {
        this.notify.errors.push("Collection is required.");
        return true;
      }

      if (this.selectedObj.endDate == null && this.selectedObj.subscriptionType == "Loan") {
        this.notify.errors.push("End date is required.");
        return true;
      }
      if (
        this.selectedObj.subscriptionType == "Loan" &&
        new Date(this.selectedObj.startDate) < new Date()
      ) {
        this.notify.errors.push(
          "Start date should be greater than current current date."
        );
        return true;
      }
      var col  = this.collection.filter((c) => c.id == this.selectedObj.collection.id);
      console.log( 'endDate ' + new Date(this.selectedObj.endDate) + '  -- ' +  new Date(col[0].endDate))

      /*
      if(col[0].endDate ==null)
      {
          this.notify.errors.push("Please contact administrator to set the end date for purchase collection.");
          return true;
      }
    */

      if (col[0].endDate != null && new Date(this.selectedObj.endDate) > new Date(col[0].endDate)) {
        this.notify.errors.push("End date should be less than or equal to purchased collection end date.");
        return true;
      }

      if (
        this.selectedObj.subscriptionType == "Loan" &&
        new Date(this.selectedObj.endDate) < new Date()
      ) {
        this.notify.errors.push(
          "End date should be greater than current current date."
        );
        return true;
      }
      if (
        this.selectedObj.subscriptionType == "Loan" &&
        new Date(this.selectedObj.endDate) > Date(this.selectedObj.startDate)
      ) {
        this.notify.errors.push("End date should be greater than start date.");
        return true;
      }

      return false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    onSubscriptionDetails(item) {
      window.location = `/groupSubscriptionDetails/${item.id}`;
    },
    onTypeChanges() {
      this.isLoan = this.selectedObj.subscriptionType == "Loan" ? true : false;
      console.log(this.isLoan);
    },
  },
  data() {
    return {
      valid: true,
      list: [],
      collection: [],
      groups: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      isLoan: true,
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      startDate: "",
      endDate: "", // new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      groupRules: [(v) => v || "Group is required"],
      collectionRules: [(v) => v || "Collection is required"],
      startDateRules: [(v) => !!v || "Start date is required"],
      endDateRules: [(v) => !!v || "End date is required"],
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      collectionEndDate :""
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgGroupSubscription.vue